export default "__VITE_ASSET__C8Y2hy6m__"